const formatPrice = (price: number) => `$${price.toLocaleString('es-AR')}`;

export default formatPrice;
